export const RQ_USER_LOGIN_API = {
  url: 'api/user/login',
  method: 'POST',
  auth: false,
};

export const RQ_USER_REGISTRATION_API = {
  url: 'api/user/register',
  method: 'POST',
  auth: false,
};

export const RQ_GET_OTP = {
  url: 'api/otp/generate/email',
  method: 'POST',
  auth: false,
};

export const RQ_VERIFY_OTP = {
  url: 'api/otp/validate',
  method: 'POST',
  auth: false,
};

export const RQ_FORGOT_PASSWORD_API = {
  url: 'api/user/forgot-password',
  method: 'PUT',
  auth: true,
  search: true,
};

export const RQ_RESET_PASSWORD_API = {
  url: 'api/user/reset-password',
  method: 'PUT',
  auth: false,
};
